/* eslint-disable no-console */
import { GraphQLFormattedError } from 'graphql';

import { writeLog } from '@/actions/write-log';

import { getServerLogger } from './loggerInstance';
import { type SEVERITY, SEVERITY_ERROR, SEVERITY_INFO, SEVERITY_WARN } from './logSeverity';

// eslint-disable-next-line no-unused-vars
type LogFunction = (severity: SEVERITY, message: string | GraphQLFormattedError) => void;

const log: LogFunction = async (severity, message) => {
  const serverLogger = getServerLogger();

  // eslint-disable-next-line no-console
  if (severity === SEVERITY_ERROR) {
    console.error(`[${severity}]: ${message}`);
  } else if (severity === SEVERITY_WARN) {
    console.warn(`[${severity}]: ${message}`);
  } else {
    console.info(`[${severity}]: ${message}`);
  }

  if (serverLogger) {
    try {
      serverLogger.log(severity, `[SSR]: ${message}`);
    } catch (error) {
      if (error instanceof Error) {
        console.error(error.message);
      }
    }
  } else {
    try {
      await writeLog({ severity, message });
    } catch {
      console.error('Cannot log error via writeLog server action');
    }
  }
};

export const logInfo = (message: string) => {
  log(SEVERITY_INFO, message);
};

export const logWarn = (message: string) => {
  log(SEVERITY_WARN, message);
};

export const logError = (message: string | GraphQLFormattedError) => {
  log(SEVERITY_ERROR, message);
};
